jQuery(function ($){
    $('.js-login-button').on('click', function (e){
        var forwardUrl = $(this).attr('href');
        var params = new URLSearchParams(window.location.search);
        var redirectUrl = params.get('redirect_url');
        if (redirectUrl) {
            var redirectDomain = redirectUrl.split('/')[2] || redirectUrl.charAt(0);
            if (redirectDomain === '/' || redirectDomain.indexOf(window.location.hostname) === 0) {
                var glue = forwardUrl.indexOf('?') === -1 ? '?': '&';
                forwardUrl += glue + 'redirect_url=' + encodeURIComponent(redirectUrl);
            }
        }
        e.preventDefault();
        window.location = forwardUrl;
    });
});